import React, { Component } from "react";
import exportToExcel from "./Excel";
const tableStyle = { tableLayout: "fixed", width: "100%", borderCollapse: "separate", borderSpacing: 0, marginTop: "10px" };
const thStyle = {
    backgroundColor: "rgb(91, 117, 55)",
    color: "white",
    fontWeight: 400,
    fontSize: "14px",
    textTransform: "none",
    padding: "6px 4px",
    border: "none",
    borderRight: "2px solid white",
    verticalAlign: "middle",
};
const tdStyle = { fontSize: "12px", padding: "6px 4px", border: "none", borderRight: "2px solid", verticalAlign: "middle", wordBreak: "break-word" };
const linkCellStyle = { overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", wordBreak: "normal" };
const dividerCss = `
    #datatables > thead > tr > th { border-color: #ffffff !important; }
    #datatables > tbody > tr:nth-child(odd) > td { border-color: #ffffff !important; }
    #datatables > tbody > tr:nth-child(even) > td { border-color: #f2f2f2 !important; }
`;
const colunas = [
    { label: "Link", width: "17%" },
    { label: "Empreendimento", width: "14%" },
    { label: "Tipo", width: "8%" },
    { label: "Status", width: "8%" },
    { label: "Categoria", width: "9%" },
    { label: "Data do Clique", width: "11%" },
    { label: "Data da Criação", width: "11%" },
    { label: "Peso", width: "5%" },
    { label: "Nome", width: "17%" },
];

class TableDetalhado extends Component {

    constructor(props) {
        super(props);
        this.state = this.props.data;

        console.log(this.state);
   
    }

    exportData = () => {
        const tableData = [];
        const headers = [];
        // Obtendo cabeçalhos da tabela
        const headerRows = document.querySelectorAll("#datatables thead th");
        headerRows.forEach((header) => headers.push(header.textContent));

        // Obtendo dados da tabela
        const rows = document.querySelectorAll("#datatables tbody tr");
        rows.forEach((row) => {
            const rowData = [];
            row.childNodes.forEach((cell) => {
                rowData.push(cell.textContent);
            });
            tableData.push(rowData);
        });

        // Preparando dados para exportação
        const exportData = [headers, ...tableData];

        // Exportando para Excel
        exportToExcel(exportData, "relatorio_analitico");
    };

    render() {
        return (
            <div className="card">
                <div className="card-body">
                    <button
                        onClick={this.exportData}
                        className="btn btn-sucess btn-link"
                    >
                        Exportar para Excel
                    </button>
                    <style>{dividerCss}</style>
                    <table
                        id="datatables"
                        className="table table-condensed"
                        style={tableStyle}
                    >
                        <thead>
                            <tr>
                                {colunas.map((coluna) => (
                                    <th key={coluna.label} className="text-center" style={{ ...thStyle, width: coluna.width }}>
                                        {coluna.label}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.data.map((index, i) => {
                                const cinza = i % 2 === 0;
                                const td = {
                                    ...tdStyle,
                                    backgroundColor: cinza ? "#f2f2f2" : "#ffffff",
                                };
                                return (
                                    <tr key={index.id ?? i}>
                                        <td className="text-center" style={{ ...td, ...linkCellStyle }}>
                                            {index.link && (
                                                <a href={index.link} target="_blank" rel="noreferrer" title={index.link} style={{ color: "#212529" }}>
                                                    {index.link}
                                                </a>
                                            )}
                                        </td>
                                        <td className="text-center" style={td}>{index.building?.name}</td>
                                        <td className="text-center" style={td}>{index.tipo}</td>
                                        <td className="text-center" style={td}>{index.status}</td>
                                        <td className="text-center" style={td}>{index.categoria}</td>
                                        <td className="text-center" style={td}>{index.categoria == "Auditoria" ? "" : index.data_clique}</td>
                                        <td className="text-center" style={td}>{index.data_criacao}</td>
                                        <td className="text-center" style={td}>{index.peso}</td>
                                        <td className="text-center" style={td}>{index.user?.name}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}


export default TableDetalhado;
